import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { useSettings } from "@/context/SettingsContext";
import { api } from "@/lib/api";

const FALLBACK = [
  "Refuge de la Foi : là où la grâce devient parure",
  "Nouvelles pièces disponibles",
];

export default function Ticker() {
  const { settings } = useSettings();
  const [visits, setVisits] = useState(null);

  useEffect(() => {
    api.get("/visits").then((r) => setVisits(r.data.count)).catch(() => {});
  }, []);

  const configured = (settings?.ticker_messages && settings.ticker_messages.length > 0)
    ? settings.ticker_messages
    : FALLBACK;

  const messages = [];
  if (visits !== null && visits > 0) {
    messages.push(`✦ Rejoignez nos ${new Intl.NumberFormat("fr-FR").format(visits)} visiteurs`);
  }
  messages.push(...configured);

  return (
    <div className="ticker-bar" data-testid="home-ticker">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {messages.map((m, i) => (
          <span
            key={i}
            className="px-12 text-sm md:text-base tracking-widest uppercase font-medium"
            data-testid={i === 0 && visits !== null ? "ticker-visitors" : undefined}
          >
            {m} ✦
          </span>
        ))}
      </Marquee>
    </div>
  );
}
